import * as React from 'react';
import { Component } from 'react';
import Backdrop from '../Backdrop/Backdrop';
import './PdfContainer.scss';

export interface PdfContainerProps {
    src: any;
    onClose?: () => void;
    showModal: boolean;
}

const PdfContainer: React.FC<PdfContainerProps> = (props) => {
    return (
        <Backdrop isShow={props.showModal} isCloseIcon={true} onClose={props.onClose} ariaLabel="Document Preview">
            {/* <iframe>, not <embed>: the CSP has object-src 'none', which blocks <embed> on UAT/prod */}
            <iframe src={props.src} className="pdfModal" title="Document Preview" />
        </Backdrop>

    );
}

export default PdfContainer;
